import React from 'react';
import AuthContext from '../../../../AuthContext';
import ConnectButton from '../../../../components/network-service/connections/ConnectButton';
import FollowButton2 from '../../../../components/network-service/follows/FollowButton2';
import OneClickLoginSignUp from '../../../../components/user-service/users/OneClickLoginSignUp';
import mtzApis from '../../../../services';

const { companyService } = mtzApis;

const CompanyFromQRDialog = ({ companyId, profileName, handleClose }) => {
    let [open, setOpen] = React.useState(true);
    let [company, setCompany] = React.useState(null);
    let [owner, setOwner] = React.useState(null);
    const me = React.useContext(AuthContext);

    React.useEffect(() => {

        (async () => {
            if (!me.userId) return;

            let company;
            if (profileName) {
                let companyes = await companyService.getCompanies(
                    new URLSearchParams(`profileName=${profileName}`)
                );
                company = companyes && companyes.length > 0 ? companyes[0] : null;
            }

            if (companyId) {
                let companyes = await companyService.getCompanyes(
                    new URLSearchParams(`companyIds=${companyId}`)
                );
                company = companyes && companyes.length > 0 ? companyes[0] : null;
            }

            if (company === null) return;
            let owner = await companyService.getUserById(company.ownerId);
            setCompany(company);
            setOwner(owner);
        })();


    }, []);

    return (
        <>
            {
                !!open &&
                (
                    !!me.userId && owner && company ?
                        <div className={`modal ${open ? 'show d-block' : ''}`}>
                            <div className='modal-dialog modal-dialog-scrollable'>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <div className='d-flex align-items-center w-100'>
                                            <h5 className='mtz-h5 m-0 flex-fill'>
                                                Company Name: {company.name}
                                            </h5>

                                            <button className='btn rounded-circle'>
                                                <span className='fa fa-close' onClick={() => setOpen(false)}></span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className='modal-body'>
                                        <div className='w-100 d-flex flex-column'>
                                            <h5 className='mtz-h6'><i>Follow or connect with us:</i></h5>
                                            <div className='d-flex align-items-center'>
                                                <div className='mr-2'>
                                                    <FollowButton2 companyId={company.id} size="sm" />
                                                </div>
                                                <div>
                                                    <ConnectButton targetUserId={company.ownerId}
                                                        companyId={company.id} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div > :
                        <div className={`modal ${open ? 'show d-block' : ''}`}>
                            <div className='modal-dialog modal-dialog-scrollable modal-lg'>
                                <div className='modal-content'>
                                    <div className='modal-header'>
                                        <div className='w-100 d-flex align-items-center'>
                                            <h5 className='m-0 flex-fill mtz-h5'>Please login or signup first</h5>

                                            <button className='btn rounded-circle' onClick={() => setOpen(false)}>
                                                <span className='fa fa-close' ></span>
                                            </button>
                                        </div>
                                    </div>

                                    <div className='modal-body overflow-auto'>
                                        <OneClickLoginSignUp />
                                    </div>
                                </div>
                            </div>
                        </div>
                )
            }
        </>
    )
}

export default CompanyFromQRDialog